export function getTextColorBasedOnNavbarColor(navbarColor) {
    if (navbarColor.startsWith("#")) {
      navbarColor = navbarColor.slice(1);
    }
  
    const r = parseInt(navbarColor.substr(0, 2), 16);
    const g = parseInt(navbarColor.substr(2, 2), 16);
    const b = parseInt(navbarColor.substr(4, 2), 16);
  
    // Calcule a luminância usando a fórmula BT.709
    const luminance = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
    const threshold = 128;
    return luminance > threshold ? "black" : "white";
  }
